import { render, staticRenderFns } from "./CardSKMata.vue?vue&type=template&id=3ad6d457&scoped=true&"
import script from "./CardSKMata.vue?vue&type=script&lang=ts&"
export * from "./CardSKMata.vue?vue&type=script&lang=ts&"
import style0 from "./CardSKMata.vue?vue&type=style&index=0&id=3ad6d457&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6d457",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
